import { Component, OnInit, inject } from '@angular/core';
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MobileSidebarComponent } from '@core/layout/components/mobile-sidebar/mobile-sidebar.component';
import { NavbarComponent } from '@core/layout/components/navbar/navbar.component';
import { SidebarComponent } from '@core/layout/components/sidebar/sidebar.component';
import { NgxSonnerToaster } from 'ngx-sonner';
import { ModalTenantLogadoComponent } from './components/navbar/modal-tenant-logado/modal-tenant-logado.component';
import { ModalTrocarSenhaComponent } from './components/navbar/modal-trocar-senha/modal-trocar-senha.component';
import { NovidadesVersaoComponent } from '@core/versao/novidades-versao/novidades-versao.component';
import { AvisoConvitesComponent } from '@core/convites/aviso-convites/aviso-convites.component';

@Component({
  selector: 'app-layout',
  imports: [
    SidebarComponent,
    NavbarComponent,
    RouterOutlet,
    NgxSonnerToaster,
    MobileSidebarComponent,
    ModalTenantLogadoComponent,
    ModalTrocarSenhaComponent,
    NovidadesVersaoComponent,
    AvisoConvitesComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit {
  private readonly router = inject(Router);

  private _mainContent: HTMLElement | null = null;

  constructor() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this._mainContent) {
          this._mainContent!.scrollTop = 0;
        }
      }
    });
  }

  ngOnInit(): void {
    this._mainContent = document.getElementById('main-content');
  }
}
